import React, { useState, useEffect } from 'react';
import { Modal, Select, Button, Alert, notification } from 'antd';

const { Option, OptGroup } = Select;

const BulkReassignModal = ({
  visible,
  eligibleCount,
  billedCount,
  billersList,
  groupsList,
  onSubmit,
  onCancel,
  loading
}) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!visible) setSelected(null);
  }, [visible]);

  const handleOk = () => {
    if (!selected) {
      notification.error({ message: 'Please select a biller or biller group.' });
      return;
    }
    let billerConfig;
    if (selected === 'any') {
      billerConfig = { billers: ['any'], billerGroups: [] };
    } else {
      const [type, id] = selected.split('__');
      billerConfig = type === 'biller'
        ? { billers: [id], billerGroups: [] }
        : { billers: [], billerGroups: [id] };
    }
    onSubmit(billerConfig);
  };

  const activeBillers = (billersList || []).filter(b => b.isEnabled);
  const activeGroups = (groupsList || []).filter(g => g.active);

  const okText = eligibleCount > 0
    ? `Reassign ${eligibleCount} Job${eligibleCount > 1 ? 's' : ''}`
    : 'Reassign';

  return (
    <Modal
      title='Bulk Reassign Jobs'
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
      style={{ top: 200 }}
      width={480}
      footer={[
        <Button key='cancel' onClick={onCancel} style={{ borderRadius: 8 }}>
          Cancel
        </Button>,
        <Button
          key='ok'
          type='primary'
          onClick={handleOk}
          loading={loading}
          disabled={eligibleCount === 0}
          style={{ borderRadius: 8 }}
        >
          {okText}
        </Button>
      ]}
    >
      {billedCount > 0 && (
        <Alert
          type='warning'
          showIcon
          style={{ marginBottom: 16 }}
          message={`${billedCount} billed job${billedCount > 1 ? 's' : ''} excluded`}
          description='Billed jobs cannot be reassigned and will be skipped.'
        />
      )}

      {eligibleCount === 0 ? (
        <Alert
          type='error'
          showIcon
          message='No eligible jobs'
          description='All selected jobs are already billed and cannot be reassigned.'
        />
      ) : (
        <>
          <p style={{ marginBottom: 16, color: '#666', fontSize: 13 }}>
            Reassigning <strong>{eligibleCount}</strong> job{eligibleCount > 1 ? 's' : ''} to:
          </p>
          <style>{`.bulk-reassign-select .ant-select-selector { border-radius: 8px !important; }`}</style>
          <Select
            placeholder='Select new biller or group'
            value={selected}
            onChange={val => setSelected(val)}
            style={{ width: '100%' }}
            className='bulk-reassign-select'
            size='large'
            allowClear
            dropdownStyle={{ borderRadius: 8 }}
          >
            <Option value='any'>Any</Option>
            {activeBillers.length > 0 && (
              <OptGroup label='Billers'>
                {activeBillers.map(b => (
                  <Option key={`biller-${b.id}`} value={`biller__${b.id}`}>
                    {b.fullName}
                  </Option>
                ))}
              </OptGroup>
            )}
            {activeGroups.length > 0 && (
              <OptGroup label='Biller Groups'>
                {activeGroups.map(g => (
                  <Option key={`group-${g.id}`} value={`group__${g.id}`}>
                    {g.groupName}
                  </Option>
                ))}
              </OptGroup>
            )}
          </Select>
        </>
      )}
    </Modal>
  );
};

export default BulkReassignModal;
